// extracted by mini-css-extract-plugin
export default {"order_statusr_list":"order_statusr_list_ytPoKH0X","order_status_iauser":"order_status_iauser_EQpQQBJY","order_status_wrapper":"order_status_wrapper_j_BEcglI"};